import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: the entire helpline / customer-care directory (brand hubs,
// country hubs, intent leaves, language mirrors). Off-topic scaled content
// on a gold/silver rate site — removed permanently.
export const Route = createFileRoute("/helpline/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
